import { useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { Helmet } from 'react-helmet';
import './ThankYou.css';

export default function ThankYou() {
  const { state } = useLocation();
  const order = state?.order;
  const confirmed = order?.payment_status === 'paid' && order?.order_number
    && order?.order_date && Number.isFinite(Number(order?.total_amount));
  // const confirmed = true;

  useEffect(() => { window.scrollTo(0, 0); }, []);

  return (
    <main className="thank-you-page">
      <Helmet>
        <title>{confirmed ? 'Thank You for Your Order' : 'Order Confirmation'} | Blisstainment</title>
        <meta name="robots" content="noindex, follow" />
      </Helmet>
      <div className="container thank-you-container">
        {!confirmed ? (
          <section className="thank-you-card thank-you-intro">
            <h1>Looking for your order?</h1>
            <p>Visit your order history to check your purchases. For a guest order, contact our support team with your order number.</p>
            <div className="thank-you-actions">
              <Link className="home_btn" to="/orderhistory">Order History</Link>
              <Link className="home_btn thank-you-outline" to="/contact-us">Contact Support</Link>
            </div>
          </section>
        ) : (
          <>
            <header className="thank-you-intro">
              <span className="thank-you-check" aria-hidden="true">✓</span>
              <h1>Thank You for Your Order!</h1>
              <p>Your order has been successfully placed.</p>
              <p>We appreciate your trust in us. We’re excited to serve you!</p>
            </header>
            <section className="thank-you-card" aria-labelledby="order-confirmation-title">
              <h2 id="order-confirmation-title">Order Confirmation</h2>
              <p>Your order is confirmed, and we’re getting everything ready. Please find your order details below for your reference.</p>
              <dl className="thank-you-details">
                <div><dt>Order Number</dt><dd>#{order?.order_number}</dd></div>
                <div><dt>Order Date</dt><dd>{new Date(order?.order_date).toLocaleDateString('en-IN', { day: 'numeric', month: 'long', year: 'numeric', timeZone: 'Asia/Kolkata' })}</dd></div>
                <div><dt>Payment Status</dt><dd><span className="thank-you-paid">Payment Successful</span></dd></div>
                <div><dt>Total Amount</dt><dd>{new Intl.NumberFormat('en-IN', { style: 'currency', currency: order?.currency || 'INR' }).format(Number(order?.total_amount))}</dd></div>
              </dl>
              <h2>What’s Next?</h2>
              <ol className="thank-you-steps">
                <li><h3>Order Confirmation</h3><p>You’ll receive an order confirmation via email with your purchase details.</p></li>
                <li><h3>Order Processing</h3><p>Our team will prepare your order and keep you informed about its progress.</p></li>
                <li><h3>Delivery Updates</h3><p>We’ll share tracking details or delivery information as soon as they’re available.</p></li>
              </ol>
              <section className="thank-you-help" id="order-support">
                <h2>Need Help?</h2>
                <p>If you have any questions about your order, our support team is here to help.</p>
                <p>Email: <a href="mailto:info@blisstainment.com">info@blisstainment.com</a></p>
                <p>Phone: <a href="tel:+918591010516">+91 85910 10516</a></p>
                {order?.order_type === 'product' && <p>For updates on your guest order, contact us with order number <strong>{order?.order_number}</strong>.</p>}
              </section>
              <footer className="thank-you-closing">
                <h2>We Appreciate Your Business!</h2>
                <p>Thank you for choosing Blisstainment. Your satisfaction is our priority, and we look forward to serving you again.</p>
                <div className="thank-you-actions">
                  <Link className="home_btn" to="/">Continue Shopping</Link>
                  {/* {order?.order_type === 'product' ? (
                    <a className="home_btn thank-you-outline" href={`mailto:info@blisstainment.com?subject=${encodeURIComponent('Order tracking: ' + order?.order_number)}`}>Track My Order</a>
                  ) : (
                    <Link className="home_btn thank-you-outline" to={`/orderhistory?order=${encodeURIComponent(order?.order_number)}`}>Track My Order</Link>
                  )}
                  <Link className="thank-you-history" to="/orderhistory">View Order History</Link> */}
                  <Link className="home_btn thank-you-outline" to="/orderhistory">View Order History</Link>
                </div>
              </footer>
            </section>
          </>
        )}
      </div>
    </main>
  );
}
